module.exports = __webpack_public_path__ + "static/media/posts-2.ce7e1f37.jpg";